import { SnapshotIn, types } from 'mobx-state-tree';
import { Instance } from 'mobx-state-tree';
export const Crop = types.model('Crop', {
  id: types.identifier,
  name: types.string,
  variety: types.string,
  genus: types.maybeNull(types.string),
  canonical_name: types.string,
  rawName: types.string
}).views(self => ({
  get toDropdownOption() {
    return {
      label: `${self.name} ${self.genus ? `(${self.genus})` : ''} - ${self.variety}`,
      value: self.id,
      canonical_name: self.canonical_name,
      name: self.name.toLowerCase(),
      variety: self.variety,
      iconName: self.rawName
    };
  }
}));
export type ICrop = Instance<typeof Crop>;
export type ICropSnapshotIn = SnapshotIn<typeof Crop>;